(function() {
    'use strict';

    var core = angular.module('app.core');

    core.config(toastrConfig);

    /* @ngInject */
    function toastrConfig(toastr) {
        toastr.options.timeOut = 4000;
        toastr.options.positionClass = 'toast-bottom-right';
    }

    var config = {
        appErrorPrefix: '[Inscripciones Error] ', //Configure the exceptionHandler decorator
        appTitle: 'Sistema Inscripciones',
        version: '1.0.0'
    };

    core.value('config', config);

    core.config(configure);

    /* @ngInject */
    function configure ($logProvider, $routeProvider, routehelperConfigProvider, exceptionHandlerProvider) {
        
        // $locationProvider.html5Mode({
        //     enabled: true,
        //     requireBase: true
        // });

        // turn debugging off/on (no info or warn)
        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(true);
        }

        // Configure the common route provider
        routehelperConfigProvider.config.$routeProvider = $routeProvider;
        routehelperConfigProvider.config.docTitle = 'Inscripciones: ';
        //var resolveAlways = { /* @ngInject */
        //    ready: function($animationsSrv) {
        //        return $animationsSrv.ready();
        //    }
        //    // ready: ['dataservice', function (dataservice) {
        //    //    return dataservice.ready();
        //    // }]
        //};
        //routehelperConfigProvider.config.resolveAlways = resolveAlways;

        // Configure the common exception handler
        exceptionHandlerProvider.configure(config.appErrorPrefix);
    }

    core.config(['$httpProvider', function ($httpProvider) {  
        $httpProvider.interceptors.push('AuthInterceptor', 'PreventTemplateCacheInterceptor');  
    }]); 

    core.config(['$qProvider', function ($qProvider) {  
        $qProvider.errorOnUnhandledRejections(false);  
    }]);  

})();
